import Banners from './Banners';
import Calendar from './Calendar';
import Checkout from './Checkout';
import Cities from './Cities';
import DiscountCode from './DiscountCode';
import Faqs from './Faqs';
import Locations from './Locations';
import NextAvailableTrips from './NextAvailableTrips';
import PaymentData from './PaymentData';
import PaymentMethods from './PaymentMethods';
import Payments from './Payments';
import QRCode from './QRCode';
import Routes from './Routes';
import Marketing from './sendgridv3/Marketing';
import setCustomer from './setCustomer';
import StaticPages from './StaticPages';
import { Subscription } from './Subscription';
import Tickets from './Tickets';
import TopDestinations from './TopDestination';
import Trips from './Trips';
import Users from './Users';

export enum AppViews {
  HOME = '/',
  HELP = '/ajuda',
  STATIC_PAGE = '/page',
  ROADMAP = '/page/nossas-linhas',
  STOPS_INFO = '/onde-embarcar',
  FAQS = '/perguntas-frequentes',
  SEARCH = '/search',
  CHECKOUT = '/checkout',
  PAYMENT_LANDING_PAGE = '/payment_status',
  PAYMENT_PENDING = '/payment_pending',
  SIGN_IN = '/entrar',
  SIGN_UP = '/sign_up',
  SIGN_IN_MOBILE = '/sign_in_mobile',
  CONFIRMATION = '/confirmation',
  CONFIRMATIONWEB = '/confirmationweb',
  DADOSCASO = '/dadoscaso',
  SIGN_UP_COMPLETED = '/sign_up_completed',
  FORGOT_PASSWORD = '/esqueci-senha',
  MANAGE_YOUR_BOOKING = '/gerencie-sua-reserva',
  ALUGUERES = '/alugueres',
  BOOKINGS = '/gerencie-sua-reserva/bookings',
  WEBTOCASE = '/webtocase',
  USER_BOOKINGS = '/users/bookings',
  USER_PROFILE = '/users/profile',
  USER_PAYMENT_METHODS = '/users/payment_methods',
  USER_ADD_PAYMENT_METHODS = '/users/payment_methods/add',
  ALTER_TRIP = '/gerencie-sua-reserva/alter_trip',
  PAYMENT_LINK = '/payment_link',
  OFFERS = 'https://go.gipsyy.pt',
  ABOUT = '/page/sobre-nos',
  BAGGAGE = '/page/bagagem',
  ANIMAL_TRANSPORT = '/page/transporte-de-animais',
  BLOG = 'https://blog.gipsyy.pt',
  DESTINATIONS = 'https://go.gipsyy.pt/rotas',
  TRUSTPILOT = 'https://trustpilot.com/review/gipsyy.com',
  TRUSTPILOT_BR = 'https://br.trustpilot.com/review/gipsyy.com',
  TRUSTPILOT_PT = 'https://pt.trustpilot.com/review/gipsyy.com',
  TRUSTPILOT_ES = 'https://es.trustpilot.com/review/gipsyy.com',
}

export enum AppViewsEn {
  HOME = '/',
  HELP = '/help',
  STATIC_PAGE = '/page',
  ROADMAP = '/page/roadmap',
  STOPS_INFO = '/stops-information',
  FAQS = '/faqs',
  SEARCH = '/search',
  CHECKOUT = '/checkout',
  PAYMENT_LANDING_PAGE = '/payment_status',
  PAYMENT_PENDING = '/payment_pending',
  SIGN_IN = '/sign_in',
  SIGN_UP = '/sign_up',
  SIGN_IN_MOBILE = '/sign_in_mobile',
  CONFIRMATION = '/confirmation',
  CONFIRMATIONWEB = '/confirmationweb',
  DADOSCASO = '/dadoscaso',
  SIGN_UP_COMPLETED = '/sign_up_completed',
  FORGOT_PASSWORD = '/forgot_password',
  MANAGE_YOUR_BOOKING = '/manage_your_booking',
  ALUGUERES = '/alugueres',
  BOOKINGS = '/manage_your_booking/bookings',
  WEBTOCASE = '/webtocase',
  USER_BOOKINGS = '/users/bookings',
  USER_PROFILE = '/users/profile',
  USER_PAYMENT_METHODS = '/users/payment_methods',
  USER_ADD_PAYMENT_METHODS = '/users/payment_methods/add',
  ALTER_TRIP = '/manage_your_booking/alter_trip',
  PAYMENT_LINK = '/payment_link',
  OFFERS = 'https://go.gipsyy.pt',
  ABOUT = '/page/sobre-nos',
  BAGGAGE = '/page/bagagem',
  ANIMAL_TRANSPORT = '/page/transporte-de-animais',
  BLOG = 'https://blog.gipsyy.pt',
  DESTINATIONS = 'https://go.gipsyy.pt/rotas',
}

const Endpoints = {
  ...Faqs,
  ...StaticPages,
  ...Marketing,
  ...Locations,
  ...Trips,
  ...Payments,
  ...PaymentMethods,
  ...Users,
  ...Tickets,
  ...Cities,
  ...DiscountCode,
  ...Subscription,
  ...NextAvailableTrips,
  ...TopDestinations,
  ...Checkout,
  ...QRCode,
  ...PaymentData,
  ...setCustomer,
  ...Calendar,
  ...Banners,
  ...Routes,
};

export default Endpoints;
